import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  endpoint: string;
};

export const meNotificationsWebpushStatus = createQueryFn(
  QueryNameSpace.meNotificationsWebpushStatus,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await DigiobcanApi.meNotificationsWebPushStatus({
      endpoint: params.endpoint,
    });

    return res.status;
  },
);
